/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Scholen_Schooljaar_Select_Aria_LabelInputs */

const nl_admin_scholen_schooljaar_select_aria_label = /** @type {(inputs: Admin_Scholen_Schooljaar_Select_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schooljaar`)
};

/**

* @param {Admin_Scholen_Schooljaar_Select_Aria_LabelInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const admin_scholen_schooljaar_select_aria_label = /** @type {((inputs?: Admin_Scholen_Schooljaar_Select_Aria_LabelInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Scholen_Schooljaar_Select_Aria_LabelInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_admin_scholen_schooljaar_select_aria_label(inputs)
});
export { admin_scholen_schooljaar_select_aria_label as "admin.scholen.schooljaar_select.aria_label" }